import { render, staticRenderFns } from "./DetailPO.vue?vue&type=template&id=406649a8&"
import script from "./DetailPO.vue?vue&type=script&lang=js&"
export * from "./DetailPO.vue?vue&type=script&lang=js&"
import style0 from "./DetailPO.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports